module.exports = __webpack_public_path__ + "img/telegram.8cd624d.svg?v=1764327952164";